export default "/images/fdcee4b7f482b1b94fce3f55843511fb.avif";